<div class="container-fluid py-3 neighborhoodPage">
  <div class="row">
    <div class="col-12">
      <div class="row">

        <!-- ---------------------------------------------------------------- -->
        <!--                    ANCHOR REPORTS KPI SECTION                    -->
        <!-- ---------------------------------------------------------------- -->
        <div class="col-12 mb-5">
          <div class="row g-3">

            <!-- ------------------------------ HEADER ----------------------------- -->
            <div class="col-12">
              <h2 class="neighborhoodPage__title mb-1">Reportes</h2>
              <p class="neighborhoodPage__subtitle mb-0">
                @if (!reportService.insightsLoading) {
                  <span class="neighborhoodPage__subtitleStrong">{{ reportsOpen }} reportes sin cerrar</span>
                }
              </p>
            </div>

            @if (reportService.insightsLoading) {

              <!-- ------------------------ LOADING SKELETON ----------------------- -->
              <div class="col-12 col-sm-6 col-xl-3" aria-hidden="true">
                <div class="neighborhoodPage__card h-100 placeholder-glow">
                  <span class="placeholder d-block col-8 rounded mb-3"></span>
                  <span class="placeholder d-block col-5 rounded neighborhoodPage__skeletonKpi"></span>
                  <span class="placeholder d-block col-10 rounded"></span>
                </div>
              </div>

              <div class="col-12 col-sm-6 col-xl-3" aria-hidden="true">
                <div class="neighborhoodPage__card h-100 placeholder-glow">
                  <span class="placeholder d-block col-8 rounded mb-3"></span>
                  <span class="placeholder d-block col-5 rounded neighborhoodPage__skeletonKpi"></span>
                  <span class="placeholder d-block col-10 rounded"></span>
                </div>
              </div>

              <div class="col-12 col-sm-6 col-xl-3" aria-hidden="true">
                <div class="neighborhoodPage__card h-100 placeholder-glow">
                  <span class="placeholder d-block col-8 rounded mb-3"></span>
                  <span class="placeholder d-block col-5 rounded neighborhoodPage__skeletonKpi"></span>
                  <span class="placeholder d-block col-10 rounded"></span>
                </div>
              </div>

              <div class="col-12 col-sm-6 col-xl-3" aria-hidden="true">
                <div class="neighborhoodPage__card h-100 placeholder-glow">
                  <span class="placeholder d-block col-8 rounded mb-3"></span>
                  <span class="placeholder d-block col-5 rounded neighborhoodPage__skeletonKpi"></span>
                  <span class="placeholder d-block col-10 rounded"></span>
                </div>
              </div>

              <div class="visually-hidden" role="status" aria-live="polite">
                Cargando resumen de reportes
              </div>

            } @else {

              <!-- --------------------------- KPI PENDING --------------------------- -->
              <div class="col-12 col-sm-6 col-xl-3">
                <a class="neighborhoodPage__cardLink"
                   [routerLink]="['/neighborhoods', neighborhoodId, 'reports', 'pendings']"
                   [attr.aria-label]="'Ver los ' + reportsPendings + ' reportes pendientes'">
                  <div class="neighborhoodPage__card h-100">
                    <p class="neighborhoodPage__cardLabel mb-1">Pendientes</p>
                    <p class="neighborhoodPage__kpiValue neighborhoodPage__kpiValueWarning mb-1">
                      {{ reportsPendings }}
                    </p>
                    <p class="neighborhoodPage__cardHint mb-0 d-flex align-items-center">
                      <i class="material-icons neighborhoodPage__cardHintIcon" aria-hidden="true">pending_actions</i>
                      <span class="text-truncate">{{ reportsPendingsPercentage }}% del total</span>
                    </p>
                  </div>
                </a>
              </div>

              <!-- -------------------------- KPI IN PROGRESS ------------------------ -->
              <div class="col-12 col-sm-6 col-xl-3">
                <a class="neighborhoodPage__cardLink"
                   [routerLink]="['/neighborhoods', neighborhoodId, 'reports', 'inProgress']"
                   [attr.aria-label]="'Ver los ' + reportsInProgress + ' reportes en progreso'">
                  <div class="neighborhoodPage__card h-100">
                    <p class="neighborhoodPage__cardLabel mb-1">En progreso</p>
                    <p class="neighborhoodPage__kpiValue neighborhoodPage__kpiValueInfo mb-1">
                      {{ reportsInProgress }}
                    </p>
                    <p class="neighborhoodPage__cardHint mb-0 d-flex align-items-center">
                      <i class="material-icons neighborhoodPage__cardHintIcon" aria-hidden="true">autorenew</i>
                      <span class="text-truncate">{{ reportsInProgressPercentage }}% del total</span>
                    </p>
                  </div>
                </a>
              </div>

              <!-- --------------------------- KPI RESOLVED -------------------------- -->
              <div class="col-12 col-sm-6 col-xl-3">
                <a class="neighborhoodPage__cardLink"
                   [routerLink]="['/neighborhoods', neighborhoodId, 'reports', 'resolved']"
                   [attr.aria-label]="'Ver los ' + reportsResolved + ' reportes resueltos'">
                  <div class="neighborhoodPage__card h-100">
                    <p class="neighborhoodPage__cardLabel mb-1">Resueltos</p>
                    <p class="neighborhoodPage__kpiValue neighborhoodPage__kpiValuePositive mb-1">
                      {{ reportsResolved }}
                    </p>
                    <p class="neighborhoodPage__cardHint mb-0 d-flex align-items-center">
                      <i class="material-icons neighborhoodPage__cardHintIcon" aria-hidden="true">task_alt</i>
                      <span class="text-truncate">{{ reportsResolvedPercentage }}% del total</span>
                    </p>
                  </div>
                </a>
              </div>

              <!-- --------------------------- KPI CANCELED -------------------------- -->
              <!-- Los cancelados cierran la tira porque son la salida que no
                   resolvió nada. No entran en "reportes sin cerrar": un reporte
                   cancelado ya está cerrado. -->
              <div class="col-12 col-sm-6 col-xl-3">
                <a class="neighborhoodPage__cardLink"
                   [routerLink]="['/neighborhoods', neighborhoodId, 'reports', 'canceled']"
                   [attr.aria-label]="'Ver los ' + reportsCanceled + ' reportes cancelados'">
                  <div class="neighborhoodPage__card h-100">
                    <p class="neighborhoodPage__cardLabel mb-1">Cancelados</p>
                    <p class="neighborhoodPage__kpiValue neighborhoodPage__kpiValueNeutral mb-1">
                      {{ reportsCanceled }}
                    </p>
                    <p class="neighborhoodPage__cardHint mb-0 d-flex align-items-center">
                      <i class="material-icons neighborhoodPage__cardHintIcon" aria-hidden="true">cancel</i>
                      <span class="text-truncate">{{ reportsCanceledPercentage }}% del total</span>
                    </p>
                  </div>
                </a>
              </div>

            }

          </div>
        </div>

        <!-- ---------------------------------------------------------------- -->
        <!--                     ANCHOR PROPERTIES SECTION                    -->
        <!-- ---------------------------------------------------------------- -->
        <div class="col-12 mb-5">
          <div class="row g-3">

            <!-- ------------------------------ HEADER ----------------------------- -->
            <div class="col-12">
              <h2 class="neighborhoodPage__title mb-1">Predios</h2>
              <p class="neighborhoodPage__subtitle mb-0">
                Estado del padrón de casas y departamentos de la colonia
              </p>
            </div>

            @if (dashboardService.loading) {

              <!-- ------------------------ LOADING SKELETON ----------------------- -->
              <div class="col-4 col-lg-4" aria-hidden="true">
                <div class="neighborhoodPage__card h-100 placeholder-glow">
                  <span class="placeholder d-block col-8 rounded mb-3"></span>
                  <span class="placeholder d-block col-5 rounded neighborhoodPage__skeletonKpi"></span>
                  <span class="placeholder d-block col-10 rounded"></span>
                </div>
              </div>

              <div class="col-4 col-lg-4" aria-hidden="true">
                <div class="neighborhoodPage__card h-100 placeholder-glow">
                  <span class="placeholder d-block col-8 rounded mb-3"></span>
                  <span class="placeholder d-block col-5 rounded neighborhoodPage__skeletonKpi"></span>
                  <span class="placeholder d-block col-10 rounded"></span>
                </div>
              </div>

              <div class="col-4 col-lg-4" aria-hidden="true">
                <div class="neighborhoodPage__card h-100 placeholder-glow">
                  <span class="placeholder d-block col-8 rounded mb-3"></span>
                  <span class="placeholder d-block col-5 rounded neighborhoodPage__skeletonKpi"></span>
                  <span class="placeholder d-block col-10 rounded"></span>
                </div>
              </div>

              <div class="col-12" aria-hidden="true">
                <div class="neighborhoodPage__card placeholder-glow">
                  <span class="placeholder d-block col-3 rounded mb-3"></span>
                  <span class="placeholder d-block col-12 rounded neighborhoodPage__skeletonChart"></span>
                </div>
              </div>

              <div class="visually-hidden" role="status" aria-live="polite">
                Cargando la información de predios
              </div>

            } @else {

              <!-- ---------------------------- KPI TOTAL ---------------------------- -->
              <div class="col-4 col-lg-4">
                <div class="neighborhoodPage__card h-100">
                  <p class="neighborhoodPage__cardLabel mb-1">No. Casas</p>
                  <p class="neighborhoodPage__kpiValue mb-1">{{ housesTotal }}</p>
                  <p class="neighborhoodPage__cardHint mb-0 d-flex align-items-center">
                    <i class="material-icons neighborhoodPage__cardHintIcon" aria-hidden="true">home_work</i>
                    <span class="text-truncate">Predios registrados</span>
                  </p>
                </div>
              </div>

              <!-- ---------------------------- KPI ACTIVE --------------------------- -->
              <div class="col-4 col-lg-4">
                <div class="neighborhoodPage__card h-100">
                  <p class="neighborhoodPage__cardLabel mb-1">Activos</p>
                  <p class="neighborhoodPage__kpiValue neighborhoodPage__kpiValuePositive mb-1">
                    {{ housesActive }}
                  </p>
                  <p class="neighborhoodPage__cardHint mb-0 d-flex align-items-center">
                    <i class="material-icons neighborhoodPage__cardHintIcon" aria-hidden="true">check_circle</i>
                    <span class="text-truncate">{{ housesActivePercentage }}% del total</span>
                  </p>
                </div>
              </div>

              <!-- --------------------------- KPI INACTIVE -------------------------- -->
              <div class="col-4 col-lg-4">
                <div class="neighborhoodPage__card h-100">
                  <p class="neighborhoodPage__cardLabel mb-1">Inactivos</p>
                  <p class="neighborhoodPage__kpiValue neighborhoodPage__kpiValueNegative mb-1">
                    {{ housesOverdue }}
                  </p>
                  <p class="neighborhoodPage__cardHint mb-0 d-flex align-items-center">
                    <i class="material-icons neighborhoodPage__cardHintIcon" aria-hidden="true">error_outline</i>
                    <span class="text-truncate">{{ housesOverduePercentage }}% del total</span>
                  </p>
                </div>
              </div>

              <!-- ------------------------ DISTRIBUTION CHART ----------------------- -->
              <div class="col-12">
                <div class="neighborhoodPage__card">

                  <div class="d-flex align-items-center justify-content-between mb-2">
                    <h3 class="neighborhoodPage__cardTitle mb-0 text-truncate">Distribución de predios</h3>
                    <span class="neighborhoodPage__cardMeta d-none d-lg-flex align-items-center">
                      <i class="material-icons neighborhoodPage__cardHintIcon" aria-hidden="true">pie_chart</i>
                      Activos frente a inactivos
                    </span>
                  </div>

                  @if (hasHousesData) {

                    <div
                      echarts
                      [options]="housesFlatsSummaryOption"
                      class="neighborhoodPage__chart"
                      role="img"
                      [attr.aria-label]="housesChartAriaLabel"></div>

                    <!-- Alternativa tabular para lectores de pantalla. -->
                    <table class="visually-hidden">
                      <caption>Distribución de predios de la colonia</caption>
                      <thead>
                        <tr>
                          <th scope="col">Estado</th>
                          <th scope="col">Predios</th>
                          <th scope="col">Porcentaje</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (item of housesDistribution; track item.name) {
                          <tr>
                            <th scope="row">{{ item.name }}</th>
                            <td>{{ item.value }}</td>
                            <td>{{ item.percentage }}%</td>
                          </tr>
                        }
                      </tbody>
                    </table>

                  } @else {

                    <div class="neighborhoodPage__emptyState d-flex flex-column align-items-center justify-content-center text-center">
                      <i class="material-icons neighborhoodPage__emptyIcon" aria-hidden="true">home_work</i>
                      <p class="neighborhoodPage__emptyTitle mb-1">Sin predios registrados</p>
                      <p class="neighborhoodPage__emptyText mb-3">
                        Aún no hay casas o departamentos dados de alta en esta colonia.
                      </p>
                      <button
                        type="button"
                        class="btn btn-outline-primary neighborhoodPage__emptyBtn"
                        (click)="getData()">
                        Volver a consultar
                      </button>
                    </div>

                  }

                </div>
              </div>

            }

          </div>
        </div>

        <!-- ---------------------------------------------------------------- -->
        <!--                       ANCHOR VISITS SECTION                      -->
        <!-- ---------------------------------------------------------------- -->
        <div class="col-12 mb-5">
          <div class="row g-3">

            <!-- ------------------------------ HEADER ------------------------------ -->
            <div class="col-12">
              <div class="row g-2 align-items-center">

                <div class="col-12 col-lg">

                  <!-- El título es una etiqueta estática: se mantiene visible durante
                       la carga, igual que en la sección de Predios. -->
                  <h2 class="neighborhoodPage__title mb-1">Visitas</h2>

                  @if (!dashboardService.loading) {

                    <p class="neighborhoodPage__subtitle mb-0">
                      <span class="neighborhoodPage__subtitleStrong">
                        {{ model | relativeDay: visitsTimeZone }}
                      </span>
                      <span class="neighborhoodPage__subtitleDivider d-none d-lg-inline" aria-hidden="true">&middot;</span>
                      <span class="d-block d-lg-inline">{{ selectedDateLabel }}</span>
                    </p>

                  } @else {

                    <!-- El fantasma conserva el mismo elemento y la misma tipografía
                         que el subtítulo real, para que la altura de la línea no
                         cambie cuando lleguen los datos. -->
                    <p class="neighborhoodPage__subtitle mb-0 placeholder-glow" aria-hidden="true">
                      <span class="placeholder rounded col-8 col-lg-5"></span>
                    </p>

                  }

                </div>

                <div class="col-12 col-lg-auto">

                  @if (!dashboardService.loading) {

                    <div class="d-flex align-items-center gap-2">

                      <label
                        for="visitsDateInput"
                        class="visually-hidden">
                        Fecha del reporte de visitas
                      </label>

                      <div class="input-group neighborhoodPage__dateGroup">
                        <button
                          class="btn btn-outline-secondary neighborhoodPage__iconBtn"
                          (click)="moveDay(-1)"
                          [disabled]="dashboardService.loading"
                          aria-label="Ver el día anterior"
                          title="Día anterior"
                          type="button">
                          <i class="material-icons" aria-hidden="true">keyboard_arrow_left</i>
                        </button>
                        <input
                          id="visitsDateInput"
                          class="form-control neighborhoodPage__dateInput"
                          placeholder="yyyy-mm-dd"
                          name="dp"
                          [(ngModel)]="model"
                          (dateSelect)="getData()"
                          ngbDatepicker
                          #d="ngbDatepicker"
                        />
                        <button
                          class="btn btn-outline-secondary neighborhoodPage__iconBtn"
                          (click)="d.toggle()"
                          aria-label="Abrir calendario para elegir la fecha"
                          title="Abrir calendario"
                          type="button">
                          <i class="material-icons" aria-hidden="true">calendar_today</i>
                        </button>
                        <button
                          class="btn btn-outline-secondary neighborhoodPage__iconBtn"
                          (click)="moveDay(1)"
                          [disabled]="dashboardService.loading"
                          aria-label="Ver el día siguiente"
                          title="Día siguiente"
                          type="button">
                          <i class="material-icons" aria-hidden="true">keyboard_arrow_right</i>
                        </button>
                      </div>

                      <button
                        (click)="getData()"
                        type="button"
                        [disabled]="dashboardService.loading"
                        aria-label="Actualizar la información de visitas"
                        title="Actualizar"
                        class="btn btn-primary neighborhoodPage__iconBtn neighborhoodPage__refreshBtn d-flex align-items-center justify-content-center">
                        <i class="material-icons" aria-hidden="true">refresh</i>
                      </button>

                    </div>

                  } @else {

                    <!-- Silueta del selector de fecha: un bloque ancho para el
                         input-group (los tres botones más el input) y un cuadro de
                         2.75rem para el botón de actualizar. Reserva el mismo espacio
                         que los controles reales para que no haya salto de layout. -->
                    <div class="d-flex align-items-center gap-2 placeholder-glow" aria-hidden="true">
                      <span class="placeholder rounded neighborhoodPage__skeletonControls neighborhoodPage__skeletonControlsGroup"></span>
                      <span class="placeholder rounded neighborhoodPage__skeletonControls neighborhoodPage__skeletonControlsBtn"></span>
                    </div>

                    <span class="visually-hidden">Cargando visitas</span>

                  }

                </div>

              </div>
            </div>

            @if (dashboardService.loading) {

              <!-- ------------------------- LOADING SKELETON ------------------------ -->
              <div class="col-12 col-lg-4" aria-hidden="true">
                <div class="neighborhoodPage__card h-100 placeholder-glow">
                  <span class="placeholder d-block col-6 rounded mb-3"></span>
                  <span class="placeholder d-block col-4 rounded neighborhoodPage__skeletonKpi"></span>
                  <span class="placeholder d-block col-8 rounded"></span>
                </div>
              </div>

              <div class="col-12 col-lg-8" aria-hidden="true">
                <div class="neighborhoodPage__card h-100 placeholder-glow">
                  <span class="placeholder d-block col-4 rounded mb-3"></span>
                  <div class="d-flex gap-3">
                    <span class="placeholder rounded flex-fill neighborhoodPage__skeletonType"></span>
                    <span class="placeholder rounded flex-fill neighborhoodPage__skeletonType"></span>
                    <span class="placeholder rounded flex-fill neighborhoodPage__skeletonType"></span>
                  </div>
                </div>
              </div>

              <div class="col-12" aria-hidden="true">
                <div class="neighborhoodPage__card placeholder-glow">
                  <span class="placeholder d-block col-3 rounded mb-3"></span>
                  <span class="placeholder d-block col-12 rounded neighborhoodPage__skeletonChart"></span>
                </div>
              </div>

              <div class="visually-hidden" role="status" aria-live="polite">
                Cargando la información de visitas
              </div>

            } @else {

              <!-- ---------------------------- KPI TOTAL ---------------------------- -->
              <div class="col-12 col-lg-4">
                <div class="neighborhoodPage__card h-100">
                  <p class="neighborhoodPage__cardLabel mb-1">Total de visitas</p>
                  <p class="neighborhoodPage__kpiValue mb-1">{{ totalVisits }}</p>

                  @if (peakHourLabel) {
                    <p class="neighborhoodPage__cardHint mb-0 d-flex align-items-center">
                      <i class="material-icons neighborhoodPage__cardHintIcon" aria-hidden="true">schedule</i>
                      <span class="text-truncate">
                        Hora pico {{ peakHourLabel }} &middot; {{ peakHourCount }} visitas
                      </span>
                    </p>
                  } @else {
                    <p class="neighborhoodPage__cardHint mb-0">Sin actividad registrada</p>
                  }
                </div>
              </div>

              <!-- ------------------------- KPI BY VISIT TYPE ----------------------- -->
              <div class="col-12 col-lg-8">
                <div class="neighborhoodPage__card h-100">
                  <p class="neighborhoodPage__cardLabel mb-2">Desglose por tipo</p>

                  @if (visitTypeSummaries.length) {

                    <div class="d-flex align-items-stretch gap-2 gap-lg-3">
                      @for (summary of visitTypeSummaries; track summary.name) {
                        <div class="neighborhoodPage__typeItem flex-fill">
                          <span class="neighborhoodPage__typeHead d-flex align-items-center">
                            <span
                              class="neighborhoodPage__typeDot"
                              [style.background-color]="summary.color"
                              aria-hidden="true"></span>
                            <span class="neighborhoodPage__typeName text-truncate" [title]="summary.name">
                              {{ summary.name }}
                            </span>
                          </span>
                          <span class="neighborhoodPage__typeValue">{{ summary.count }}</span>
                          <span class="neighborhoodPage__typePercent">{{ summary.percentage }}%</span>
                        </div>
                      }
                    </div>

                  } @else {
                    <p class="neighborhoodPage__cardHint mb-0">Sin visitas registradas este día</p>
                  }
                </div>
              </div>

              <!-- ------------------------------ CHART ------------------------------ -->
              <div class="col-12">
                <div class="neighborhoodPage__card">

                  <div class="d-flex align-items-center justify-content-between mb-2">
                    <h3 class="neighborhoodPage__cardTitle mb-0 text-truncate">Visitas por hora</h3>
                    <span class="neighborhoodPage__cardMeta d-none d-lg-flex align-items-center">
                      <i class="material-icons neighborhoodPage__cardHintIcon" aria-hidden="true">public</i>
                      Horario local de la colonia (UTC{{ visitsTimeZone }})
                    </span>
                  </div>

                  @if (hasVisits) {

                    <div
                      echarts
                      [options]="visitsTodaySummaryChartOptions!"
                      class="neighborhoodPage__chart"
                      role="img"
                      [attr.aria-label]="chartAriaLabel"></div>

                    <!-- Alternativa tabular para lectores de pantalla. -->
                    <table class="visually-hidden">
                      <caption>Visitas por hora del {{ selectedDateLabel }}</caption>
                      <thead>
                        <tr>
                          <th scope="col">Hora</th>
                          @for (summary of visitTypeSummaries; track summary.name) {
                            <th scope="col">{{ summary.name }}</th>
                          }
                          <th scope="col">Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (row of hourlyTableRows; track row.hour) {
                          <tr>
                            <th scope="row">{{ row.hour }}</th>
                            @for (count of row.counts; track $index) {
                              <td>{{ count }}</td>
                            }
                            <td>{{ row.total }}</td>
                          </tr>
                        }
                      </tbody>
                    </table>

                  } @else {

                    <div class="neighborhoodPage__emptyState d-flex flex-column align-items-center justify-content-center text-center">
                      <i class="material-icons neighborhoodPage__emptyIcon" aria-hidden="true">event_busy</i>
                      <p class="neighborhoodPage__emptyTitle mb-1">Sin visitas este día</p>
                      <p class="neighborhoodPage__emptyText mb-3">
                        No se registraron accesos el {{ selectedDateLabel }}. Elige otra fecha o vuelve a consultar.
                      </p>
                      <button
                        type="button"
                        class="btn btn-outline-primary neighborhoodPage__emptyBtn"
                        (click)="getData()">
                        Volver a consultar
                      </button>
                    </div>

                  }

                </div>
              </div>

            }

          </div>
        </div>

        <!-- ---------------------------------------------------------------- -->
        <!--                    ANCHOR CURRENT MONTH SECTION                  -->
        <!-- ---------------------------------------------------------------- -->
        <div class="col-12 mb-5">
          <div class="row g-3">

            <!-- ------------------------------ HEADER ----------------------------- -->
            <div class="col-12">
              <h2 class="neighborhoodPage__title mb-1">Mes Actual</h2>
              <p class="neighborhoodPage__subtitle mb-0">
                <span class="neighborhoodPage__subtitleStrong">{{ currentMonthLabel }}</span>
                <span class="neighborhoodPage__subtitleDivider d-none d-lg-inline" aria-hidden="true">&middot;</span>
                <span class="d-block d-lg-inline">Comparado con {{ lastMonthLabel }}</span>
              </p>
            </div>

            @if (dashboardService.loading) {

              <!-- ------------------------ LOADING SKELETON ----------------------- -->
              <!-- El fantasma ocupa el mismo ancho que la tarjeta que va a sustituir. -->
              <div
                [ngClass]="authService.currentUser?.profile === 'sudo' ? 'col-4 col-lg-4' : 'col-12'"
                aria-hidden="true">
                <div class="neighborhoodPage__card h-100 placeholder-glow">
                  <span class="placeholder d-block col-8 rounded mb-3"></span>
                  <span class="placeholder d-block col-5 rounded neighborhoodPage__skeletonKpi"></span>
                  <span class="placeholder d-block col-10 rounded"></span>
                </div>
              </div>

              @if(authService.currentUser?.profile === 'sudo') {

                <div class="col-4 col-lg-4" aria-hidden="true">
                  <div class="neighborhoodPage__card h-100 placeholder-glow">
                    <span class="placeholder d-block col-8 rounded mb-3"></span>
                    <span class="placeholder d-block col-5 rounded neighborhoodPage__skeletonKpi"></span>
                    <span class="placeholder d-block col-10 rounded"></span>
                  </div>
                </div>

                <div class="col-4 col-lg-4" aria-hidden="true">
                  <div class="neighborhoodPage__card h-100 placeholder-glow">
                    <span class="placeholder d-block col-8 rounded mb-3"></span>
                    <span class="placeholder d-block col-5 rounded neighborhoodPage__skeletonKpi"></span>
                    <span class="placeholder d-block col-10 rounded"></span>
                  </div>
                </div>

              }

              <div class="col-12 col-lg-6" aria-hidden="true">
                <div class="neighborhoodPage__card h-100 placeholder-glow">
                  <span class="placeholder d-block col-4 rounded mb-3"></span>
                  <span class="placeholder d-block col-12 rounded neighborhoodPage__skeletonChart"></span>
                </div>
              </div>

              <div class="col-12 col-lg-6" aria-hidden="true">
                <div class="neighborhoodPage__card h-100 placeholder-glow">
                  <span class="placeholder d-block col-4 rounded mb-3"></span>
                  <span class="placeholder d-block col-12 rounded neighborhoodPage__skeletonChart"></span>
                </div>
              </div>

              <div class="visually-hidden" role="status" aria-live="polite">
                Cargando la información del mes actual
              </div>

            } @else {

              <!-- ----------------------- KPI CURRENT MONTH ------------------------ -->
              <!-- Sin comparativos la tarjeta toma el ancho completo: no se crea otra fila. -->
              <div [ngClass]="authService.currentUser?.profile === 'sudo' ? 'col-4 col-lg-4' : 'col-12'">
                <div class="neighborhoodPage__card h-100">
                  <p class="neighborhoodPage__cardLabel mb-1">Visitas del mes</p>
                  <p class="neighborhoodPage__kpiValue mb-1">{{ visitsCurrentMonth }}</p>
                  <p class="neighborhoodPage__cardHint mb-0 d-flex align-items-center">
                    <i class="material-icons neighborhoodPage__cardHintIcon" aria-hidden="true">event_available</i>
                    <span class="text-truncate">{{ currentMonthLabel }}</span>
                  </p>
                </div>
              </div>

              @if(authService.currentUser?.profile === 'sudo') {

                <!-- ----------------------- KPI LAST MONTH ------------------------ -->
                <div class="col-4 col-lg-4">
                  <div class="neighborhoodPage__card h-100">
                    <p class="neighborhoodPage__cardLabel mb-1">Mes anterior</p>
                    <p class="neighborhoodPage__kpiValue mb-1">{{ visitsLastMonth }}</p>
                    <p class="neighborhoodPage__cardHint mb-0 d-flex align-items-center">
                      <i class="material-icons neighborhoodPage__cardHintIcon" aria-hidden="true">history</i>
                      <span class="text-truncate">{{ lastMonthLabel }}</span>
                    </p>
                  </div>
                </div>

                <!-- ------------------------ KPI VARIATION ------------------------ -->
                <div class="col-4 col-lg-4">
                  <div class="neighborhoodPage__card h-100">
                    <p class="neighborhoodPage__cardLabel mb-1">Variación</p>

                    <p
                      class="neighborhoodPage__kpiValue mb-1 d-flex align-items-center gap-1"
                      [class.neighborhoodPage__kpiValuePositive]="monthVariationDirection === 'up'"
                      [class.neighborhoodPage__kpiValueNegative]="monthVariationDirection === 'down'">
                      <i
                        class="material-icons neighborhoodPage__trendIcon"
                        [class.neighborhoodPage__trendUp]="monthVariationDirection === 'up'"
                        [class.neighborhoodPage__trendDown]="monthVariationDirection === 'down'"
                        [class.neighborhoodPage__trendFlat]="monthVariationDirection !== 'up' && monthVariationDirection !== 'down'"
                        aria-hidden="true">
                        {{ monthVariationIcon }}
                      </i>
                      <span class="text-truncate">{{ monthVariationValue }}</span>
                    </p>

                    <!-- El texto explica el sentido: el color nunca es el único indicador. -->
                    <p class="neighborhoodPage__cardHint mb-0">{{ monthVariationText }}</p>
                  </div>
                </div>

              }

              <!-- ---------------------- VISIT TYPES DONUT CHART ------------------- -->
              <div class="col-12 col-lg-6">
                <div class="neighborhoodPage__card h-100">

                  <div class="d-flex align-items-center justify-content-between mb-2">
                    <h3 class="neighborhoodPage__cardTitle mb-0 text-truncate">Tipos de visita del mes</h3>
                    <span class="neighborhoodPage__cardMeta d-none d-lg-flex align-items-center">
                      <i class="material-icons neighborhoodPage__cardHintIcon" aria-hidden="true">donut_small</i>
                      Total {{ visitTypesMonthTotal }}
                    </span>
                  </div>

                  @if (hasVisitTypesData) {

                    <div
                      echarts
                      [options]="visitTypeSummaryChart"
                      class="neighborhoodPage__chart"
                      role="img"
                      [attr.aria-label]="visitTypesChartAriaLabel"></div>

                    <!-- Alternativa tabular para lectores de pantalla. -->
                    <table class="visually-hidden">
                      <caption>Tipos de visita del mes actual</caption>
                      <thead>
                        <tr>
                          <th scope="col">Tipo</th>
                          <th scope="col">Visitas</th>
                          <th scope="col">Porcentaje</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (item of visitTypesMonthSummaries; track item.name) {
                          <tr>
                            <th scope="row">{{ item.name }}</th>
                            <td>{{ item.value }}</td>
                            <td>{{ item.percentage }}%</td>
                          </tr>
                        }
                      </tbody>
                    </table>

                  } @else {

                    <div class="neighborhoodPage__emptyState d-flex flex-column align-items-center justify-content-center text-center">
                      <i class="material-icons neighborhoodPage__emptyIcon" aria-hidden="true">donut_large</i>
                      <p class="neighborhoodPage__emptyTitle mb-1">Sin visitas este mes</p>
                      <p class="neighborhoodPage__emptyText mb-3">
                        Todavía no hay accesos registrados en {{ currentMonthLabel }}.
                      </p>
                      <button
                        type="button"
                        class="btn btn-outline-primary neighborhoodPage__emptyBtn"
                        (click)="getData()">
                        Volver a consultar
                      </button>
                    </div>

                  }

                </div>
              </div>

              <!-- ----------------------- SERVICES DONUT CHART --------------------- -->
              <div class="col-12 col-lg-6">
                <div class="neighborhoodPage__card h-100">

                  <div class="d-flex align-items-center justify-content-between mb-2">
                    <h3 class="neighborhoodPage__cardTitle mb-0 text-truncate">Servicios del mes</h3>
                    <span class="neighborhoodPage__cardMeta d-none d-lg-flex align-items-center">
                      <i class="material-icons neighborhoodPage__cardHintIcon" aria-hidden="true">donut_small</i>
                      Total {{ servicesMonthTotal }}
                    </span>
                  </div>

                  @if (hasServicesData) {

                    <div
                      echarts
                      [options]="serviceSummaryPieChart"
                      class="neighborhoodPage__chart"
                      role="img"
                      [attr.aria-label]="servicesPieChartAriaLabel"></div>

                  } @else {

                    <div class="neighborhoodPage__emptyState d-flex flex-column align-items-center justify-content-center text-center">
                      <i class="material-icons neighborhoodPage__emptyIcon" aria-hidden="true">donut_large</i>
                      <p class="neighborhoodPage__emptyTitle mb-1">Sin servicios este mes</p>
                      <p class="neighborhoodPage__emptyText mb-3">
                        Todavía no hay entradas de servicio registradas en {{ currentMonthLabel }}.
                      </p>
                      <button
                        type="button"
                        class="btn btn-outline-primary neighborhoodPage__emptyBtn"
                        (click)="getData()">
                        Volver a consultar
                      </button>
                    </div>

                  }

                </div>
              </div>

            }

          </div>
        </div>

        <!-- ---------------------------------------------------------------- -->
        <!--                      ANCHOR SERVICES SECTION                     -->
        <!-- ---------------------------------------------------------------- -->
        <div class="col-12 mb-5">
          <div class="row g-3">

            <!-- ------------------------------ HEADER ----------------------------- -->
            <div class="col-12">
              <h2 class="neighborhoodPage__title mb-1">Servicios</h2>
              <p class="neighborhoodPage__subtitle mb-0">
                Entradas de servicio registradas durante {{ currentMonthLabel }}
              </p>
            </div>

            @if (dashboardService.loading) {

              <!-- ------------------------ LOADING SKELETON ----------------------- -->
              <div class="col-12" aria-hidden="true">
                <div class="neighborhoodPage__card placeholder-glow">
                  <span class="placeholder d-block col-3 rounded mb-3"></span>
                  <span class="placeholder d-block col-12 rounded neighborhoodPage__skeletonChart"></span>
                </div>
              </div>

              <div class="visually-hidden" role="status" aria-live="polite">
                Cargando la información de servicios
              </div>

            } @else {

              <div class="col-12">
                <div class="neighborhoodPage__card">

                  <div class="d-flex align-items-center justify-content-between mb-2">
                    <h3 class="neighborhoodPage__cardTitle mb-0 text-truncate">Entradas por servicio</h3>
                    <span class="neighborhoodPage__cardMeta d-none d-lg-flex align-items-center">
                      <i class="material-icons neighborhoodPage__cardHintIcon" aria-hidden="true">bar_chart</i>
                      Total {{ servicesMonthTotal }}
                    </span>
                  </div>

                  @if (hasServicesData) {

                    <div
                      echarts
                      [options]="servicesSummary"
                      class="neighborhoodPage__chart"
                      role="img"
                      [attr.aria-label]="servicesChartAriaLabel"></div>

                    <!-- Alternativa tabular para lectores de pantalla. -->
                    <table class="visually-hidden">
                      <caption>Entradas por servicio del mes actual</caption>
                      <thead>
                        <tr>
                          <th scope="col">Servicio</th>
                          <th scope="col">Visitas</th>
                          <th scope="col">Porcentaje</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (item of servicesMonthSummaries; track item.name) {
                          <tr>
                            <th scope="row">{{ item.name }}</th>
                            <td>{{ item.value }}</td>
                            <td>{{ item.percentage }}%</td>
                          </tr>
                        }
                      </tbody>
                    </table>

                  } @else {

                    <div class="neighborhoodPage__emptyState d-flex flex-column align-items-center justify-content-center text-center">
                      <i class="material-icons neighborhoodPage__emptyIcon" aria-hidden="true">home_repair_service</i>
                      <p class="neighborhoodPage__emptyTitle mb-1">Sin entradas de servicio</p>
                      <p class="neighborhoodPage__emptyText mb-3">
                        No se registraron entradas de servicio en {{ currentMonthLabel }}.
                      </p>
                      <button
                        type="button"
                        class="btn btn-outline-primary neighborhoodPage__emptyBtn"
                        (click)="getData()">
                        Volver a consultar
                      </button>
                    </div>

                  }

                </div>
              </div>

            }

          </div>
        </div>

        <!-- ---------------------------------------------------------------- -->
        <!--                      ANCHOR REPORTS SECTION                      -->
        <!-- ---------------------------------------------------------------- -->
        <div class="col-12 mb-5">
          <div class="row g-3">

            <!-- ------------------------------ HEADER ----------------------------- -->
            <div class="col-12">
              <h2 class="neighborhoodPage__title mb-1">Detalle de reportes</h2>
              <p class="neighborhoodPage__subtitle mb-0">
                <span class="d-block d-lg-inline">Distribuci&oacute;n, tendencia y &uacute;ltimos reportes</span>
              </p>
            </div>

            @if (reportService.insightsLoading) {

              <div class="col-12 col-lg-6" aria-hidden="true">
                <div class="neighborhoodPage__card h-100 placeholder-glow">
                  <span class="placeholder d-block col-4 rounded mb-3"></span>
                  <span class="placeholder d-block col-12 rounded neighborhoodPage__skeletonChart"></span>
                </div>
              </div>

              <div class="col-12 col-lg-6" aria-hidden="true">
                <div class="neighborhoodPage__card h-100 placeholder-glow">
                  <span class="placeholder d-block col-4 rounded mb-3"></span>
                  <span class="placeholder d-block col-12 rounded neighborhoodPage__skeletonChart"></span>
                </div>
              </div>

              <div class="col-12" aria-hidden="true">
                <div class="neighborhoodPage__card placeholder-glow">
                  <span class="placeholder d-block col-3 rounded mb-3"></span>
                  <span class="placeholder d-block col-12 rounded neighborhoodPage__skeletonReportItem mb-2"></span>
                  <span class="placeholder d-block col-12 rounded neighborhoodPage__skeletonReportItem mb-2"></span>
                  <span class="placeholder d-block col-12 rounded neighborhoodPage__skeletonReportItem mb-2"></span>
                  <span class="placeholder d-block col-12 rounded neighborhoodPage__skeletonReportItem mb-2"></span>
                  <span class="placeholder d-block col-12 rounded neighborhoodPage__skeletonReportItem"></span>
                </div>
              </div>

              <div class="visually-hidden" role="status" aria-live="polite">
                Cargando reportes
              </div>

            } @else {

              <!-- ------------------------ DISTRIBUTION CHART ----------------------- -->
              <div class="col-12 col-lg-6">
                <div class="neighborhoodPage__card h-100">

                  <div class="d-flex align-items-center justify-content-between mb-2">
                    <h3 class="neighborhoodPage__cardTitle mb-0 text-truncate">Distribución por estado</h3>
                    <span class="neighborhoodPage__cardMeta d-none d-lg-flex align-items-center">
                      <i class="material-icons neighborhoodPage__cardHintIcon" aria-hidden="true">donut_small</i>
                      {{ reportsAverageResolutionLabel }}
                    </span>
                  </div>

                  @if (hasReportsData) {

                    <div
                      echarts
                      [options]="reportsStatusDonutOption"
                      class="neighborhoodPage__chart"
                      role="img"
                      [attr.aria-label]="reportsDonutAriaLabel"></div>

                    <!-- Alternativa tabular para lectores de pantalla. -->
                    <table class="visually-hidden">
                      <caption>Distribución de reportes por estado</caption>
                      <thead>
                        <tr>
                          <th scope="col">Estado</th>
                          <th scope="col">Reportes</th>
                          <th scope="col">Porcentaje</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (item of reportsDistribution; track item.name) {
                          <tr>
                            <th scope="row">{{ item.name }}</th>
                            <td>{{ item.value }}</td>
                            <td>{{ item.percentage }}%</td>
                          </tr>
                        }
                      </tbody>
                    </table>

                  } @else {

                    <div class="neighborhoodPage__emptyState d-flex flex-column align-items-center justify-content-center text-center">
                      <i class="material-icons neighborhoodPage__emptyIcon" aria-hidden="true">assignment_late</i>
                      <p class="neighborhoodPage__emptyTitle mb-1">Sin reportes registrados</p>
                      <p class="neighborhoodPage__emptyText mb-3">
                        Aún no hay reportes pendientes, en progreso ni resueltos en esta colonia.
                      </p>
                      <button
                        type="button"
                        class="btn btn-outline-primary neighborhoodPage__emptyBtn"
                        (click)="getData()">
                        Volver a consultar
                      </button>
                    </div>

                  }

                </div>
              </div>

              <!-- --------------------------- TREND CHART --------------------------- -->
              <div class="col-12 col-lg-6">
                <div class="neighborhoodPage__card h-100">

                  <div class="d-flex align-items-center justify-content-between mb-2">
                    <h3 class="neighborhoodPage__cardTitle mb-0 text-truncate">Reportes por mes</h3>
                    <span class="neighborhoodPage__cardMeta d-none d-lg-flex align-items-center">
                      <i class="material-icons neighborhoodPage__cardHintIcon" aria-hidden="true">stacked_bar_chart</i>
                      Últimos 6 meses
                    </span>
                  </div>

                  <!-- La flecha nunca va sola: el texto explica el sentido del cambio. -->
                  <p class="neighborhoodPage__cardHint mb-2 d-flex align-items-center">
                    <i
                      class="material-icons neighborhoodPage__cardHintIcon"
                      [class.neighborhoodPage__trendUp]="reportsMonthVariationDirection === 'up'"
                      [class.neighborhoodPage__trendDown]="reportsMonthVariationDirection === 'down'"
                      [class.neighborhoodPage__trendFlat]="reportsMonthVariationDirection !== 'up' && reportsMonthVariationDirection !== 'down'"
                      aria-hidden="true">{{ reportsMonthVariationIcon }}</i>
                    <span class="text-truncate">
                      {{ reportsMonthTotal }} este mes &middot; {{ reportsMonthVariationValue }} &middot; {{ reportsMonthVariationText }}
                    </span>
                  </p>

                  @if (hasReportsMonthlyData) {

                    <div
                      echarts
                      [options]="reportsMonthlyOption"
                      class="neighborhoodPage__chart"
                      role="img"
                      [attr.aria-label]="reportsMonthlyAriaLabel"></div>

                    <!-- Alternativa tabular para lectores de pantalla. -->
                    <table class="visually-hidden">
                      <caption>Reportes por mes y estado</caption>
                      <thead>
                        <tr>
                          <th scope="col">Mes</th>
                          <th scope="col">Pendientes</th>
                          <th scope="col">En progreso</th>
                          <th scope="col">Resueltos</th>
                          <th scope="col">Cancelados</th>
                          <th scope="col">Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (row of reportsMonthlyRows; track row.month) {
                          <tr>
                            <th scope="row">{{ row.label }}</th>
                            <td>{{ row.pendings }}</td>
                            <td>{{ row.inProgress }}</td>
                            <td>{{ row.resolved }}</td>
                            <td>{{ row.canceled }}</td>
                            <td>{{ row.total }}</td>
                          </tr>
                        }
                      </tbody>
                    </table>

                  } @else {

                    <div class="neighborhoodPage__emptyState d-flex flex-column align-items-center justify-content-center text-center">
                      <i class="material-icons neighborhoodPage__emptyIcon" aria-hidden="true">assignment_late</i>
                      <p class="neighborhoodPage__emptyTitle mb-1">Sin reportes registrados</p>
                      <p class="neighborhoodPage__emptyText mb-3">
                        Aún no hay reportes pendientes, en progreso ni resueltos en esta colonia.
                      </p>
                      <button
                        type="button"
                        class="btn btn-outline-primary neighborhoodPage__emptyBtn"
                        (click)="getData()">
                        Volver a consultar
                      </button>
                    </div>

                  }

                </div>
              </div>

              <!-- --------------------------- LATEST REPORTS ------------------------ -->
              <div class="col-12">
                <div class="neighborhoodPage__card">

                  <div class="d-flex align-items-center justify-content-between mb-2">
                    <h3 class="neighborhoodPage__cardTitle mb-0 text-truncate">Últimos reportes</h3>
                    <span class="neighborhoodPage__cardMeta d-none d-lg-flex align-items-center">
                      <i class="material-icons neighborhoodPage__cardHintIcon" aria-hidden="true">receipt_long</i>
                      Los 5 más recientes
                    </span>
                  </div>

                  @if (hasLatestReports) {

                    <ul class="list-unstyled d-flex flex-column gap-2 mb-0">
                      @for (item of latestReports; track item.reportId) {
                        <li>
                          <a
                            class="neighborhoodPage__reportItem"
                            [routerLink]="['/neighborhoods', neighborhoodId, 'reports']">

                            <span class="neighborhoodPage__statusChip" [ngClass]="item.statusClass">
                              <i class="material-icons neighborhoodPage__statusChipIcon" aria-hidden="true">{{ item.statusIcon }}</i>
                              {{ item.statusName }}
                            </span>

                            <span class="d-flex flex-column flex-grow-1">
                              <span class="neighborhoodPage__reportItemTitle text-truncate" [title]="item.title">
                                {{ item.title }}
                              </span>
                              <span class="neighborhoodPage__reportItemMeta text-truncate" [title]="item.locationLabel">
                                {{ item.locationLabel }}
                                <span aria-hidden="true">&middot;</span>
                                <time [attr.datetime]="item.dateTime">{{ item.dateLabel }}</time>
                              </span>
                            </span>

                            <i class="material-icons neighborhoodPage__reportItemChevron" aria-hidden="true">chevron_right</i>

                          </a>
                        </li>
                      }
                    </ul>

                    <p class="neighborhoodPage__cardHint mb-0 mt-3 text-end">
                      <a [routerLink]="['/neighborhoods', neighborhoodId, 'reports']">
                        Ver todos los reportes
                      </a>
                    </p>

                  } @else {

                    <div class="neighborhoodPage__emptyState d-flex flex-column align-items-center justify-content-center text-center">
                      <i class="material-icons neighborhoodPage__emptyIcon" aria-hidden="true">inbox</i>
                      <p class="neighborhoodPage__emptyTitle mb-1">Sin reportes recientes</p>
                      <p class="neighborhoodPage__emptyText mb-3">
                        Cuando los residentes levanten un reporte aparecerá aquí.
                      </p>
                      <button
                        type="button"
                        class="btn btn-outline-primary neighborhoodPage__emptyBtn"
                        (click)="getData()">
                        Volver a consultar
                      </button>
                    </div>

                  }

                </div>
              </div>

            }

          </div>
        </div>

      </div>
    </div>
  </div>
</div>
